export const ParentBreadCrumbsName = 'parentBreadCrumbsComponent';
